import PrivacyCenter from "../components/PrivacyCenter";
export default function CustomerPrivacy() {
  return <div className="mx-auto max-w-2xl space-y-5"><div><h1 className="text-2xl font-semibold">Privacy &amp; Account</h1><p className="mt-1 text-sm text-slate-600">Export your verified customer data or manage your deletion request.</p></div><PrivacyCenter context="customer" /></div>;
}
